import ButtonsGroup from './buttons-group';

export default ButtonsGroup;